
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.75 12.792h9.5v-1.584h-9.5v1.584zM2.375 7.25v1.583h14.25V7.25H2.375zm5.542 9.5h3.166v-1.583H7.917v1.583z"}}),_c('path',{attrs:{"d":"M18.467 18.5a2.975 2.975 0 00-2.967-2.967 2.975 2.975 0 00-2.967 2.967 2.975 2.975 0 002.967 2.967 2.975 2.975 0 002.967-2.967zm-1.136 1.352l-3.186-3.186c.364-.29.832-.45 1.355-.45a2.29 2.29 0 012.283 2.284c0 .492-.183.96-.452 1.352zM13.217 18.5c0-.523.159-.991.45-1.355l3.188 3.189c-.364.29-.832.45-1.355.45a2.29 2.29 0 01-2.283-2.284z","fill":"#BF360C","stroke":"#BF360C","stroke-width":".1"}})])
          )
        }
      }
    